import React from 'react';
import AuthCallbackPage from './AuthCallbackPage';

const ResetPasswordPage = () => {
  return <AuthCallbackPage headline="Reset your password in the app" />;
};

export default ResetPasswordPage;
